import { EventReportFilter } from '@contexts/event-report/event-report-context.type';
import { EventChannelsSalesStatsResponse, EventSalesStatsParams } from '@domain/event-report';
import { useGenericQuery } from '@hooks/use-generic-query';
import { paramsSerializer } from '@utils/format-params';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';

export const createEventChannelsSalesStatsKey = (eventId: string | undefined, params?: EventReportFilter) => [
  QUERY_KEYS.eventChannelsSalesStats,
  eventId,
  params,
];

const getEventChannelsSalesStats = async ({ eventId, params }: EventSalesStatsParams) => {
  const queryParams = paramsSerializer({ ...params });
  const url = `${import.meta.env.VITE_MONOLITH_HOST}/v1/nightgraph/events/${eventId}/channels-sales-stats?${queryParams}`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetEventChannelsSalesStats = ({ eventId, params, options }: EventSalesStatsParams) => {
  return useGenericQuery<EventChannelsSalesStatsResponse, RequestError>(
    createEventChannelsSalesStatsKey(eventId, params),
    () => getEventChannelsSalesStats({ eventId, params }),
    {
      ...options,
    }
  );
};
